export enum selectContentEvent {
  selectContent = "select_content"
}

export enum selectContentAction {
  filter = "filter"
}
